import React from "react";

function InsuranceReinsurance() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Insurance and reinsurance</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              This area of law mainly involves disputes on insurers and in turn their insurers.  It highly depends on the prevalent conditions in the market.
              </p>
              <p>
              This area will usually involve claims and our role will be to advise on such claims.  If matters escalate to court then it is our role to represent our clients.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default InsuranceReinsurance;
